import { injectIntl } from "react-intl";
import validator from "validator";
import { Formik } from "formik";
import {
  intlShape,
  Form,
  isTouchDevice,
  TextInput,
  SubmitButton,
  isEmpty,
} from "lcm-iot-commons";
import Captcha from "../Captcha/Captcha";

type OwnProps = {
  intl: intlShape;
  onSubmit?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  onSubmit: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function RequestPasswordResetForm({ intl, onSubmit }: Props) {
  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (isEmpty(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.mandatory",
      });
    } else if (!validator.isEmail(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.invalid",
      });
    }
    if (!values.captcha) {
      (errors as $TSFixMe).captcha = intl.formatMessage({
        id: "validation.captcha.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;

    return (
      <Form {...formProps}>
        <div className="form-group">
          <TextInput
            {...formProps}
            name="email"
            id="email"
            component={TextInput}
            label={intl.formatMessage({ id: "password_reset.email" })}
            disabled={isSubmitting}
            autoFocus={!isTouchDevice()}
            required
          />
        </div>
        <Captcha {...formProps} name="captcha" />
        <SubmitButton
          id="send-verification-email"
          name="send-verification-email"
          disabled={!formProps.dirty}
          fetching={isSubmitting}
          text={intl.formatMessage({
            id: "password_reset.send_verification_email",
          })}
        />
      </Form>
    );
  };

  return (
    <div className="row">
      <div className="col-md-6" id="request-password-reset-init">
        <h1>{intl.formatMessage({ id: "password_reset.header" })}</h1>
        <p>{intl.formatMessage({ id: "password_reset.provide_username" })}</p>
        <p>
          {intl.formatMessage({ id: "password_reset.we_send_you_an_email" })}
        </p>
        <div className="form-group">
          <Formik
            id="edit-mail-form"
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onSubmit={onSubmit}
            validate={validateForm}
            initialValues={{}}
          >
            {renderForm}
          </Formik>
        </div>
      </div>
    </div>
  );
}

RequestPasswordResetForm.defaultProps = defaultProps;

export default injectIntl(RequestPasswordResetForm);
